// extracted by mini-css-extract-plugin
export var csatScore = "_hk-5";
export var header = "_hk-1";
export var panelWrapper = "_hk-2";
export var postPreview = "_hk-3";
export var rightContent = "_hk-0";
export var wrappingText = "_hk-4";